module.exports = __webpack_public_path__ + "static/media/10.125211e0.png";